/* eslint-disable */
import './qrIndex.css';
import React, { useState, useEffect, useCallback } from 'react';
import {
  FaSortDown,
  FaPlus,
  FaExternalLinkAlt,
} from 'react-icons/fa';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import Button from '@mui/material/Button';
import { Box } from '@mui/material';
import { customBaseUrl, httpGet, httpPost, httpPut } from '../../store/http';
import GeneratedQr from './generatedQrModal';
import { Col, Progress, Row, Select, Tabs, Menu, Dropdown } from 'antd';
import ExportQr from './exportCards';
import GenCard from './genCards';
import { hideLoader, showLoader } from '../../utils/loader';
import Swal from 'sweetalert2';
import moment from 'moment';

const { TabPane } = Tabs;


const Date = () => {
  const [active, setActive] = useState(false);
  return (
    <div className="dropdown date-dropdown">
      <div
        className="dropdown-btn date-dropdown-btn"
        onClick={(e) => setActive(!active)}
      >
        {' '}
        Date
        <p className="arrow-down">
          <FaSortDown />
        </p>
      </div>
      {active && (
        <div className="dropdown-content date-dropdown-content">
          <div className="dropdown-item date-dropdown-item">
            <h6 className="start-date">Start Date</h6>
            <input type="date" />
          </div>
          <div className="dropdown-item date-dropdown-item">
            <h6 className="end-date">End State</h6>
            <input type="date" />
          </div>
        </div>
      )}
    </div>
  );
};

const Search = ({ selected, setSelectedCards, selectedCards, getAll, refresh, setRefresh, setOpenExport, setOpenExcel, setSelected, handleManageMarketers }) => {
  const [openGenerateModal, setOpenGenerateModal] = useState(false);
  const [count, setCount] = useState("");
  const [showProgress, setShowProgress] = useState(false);
  const [prog, setProg] = useState(0);


  const handleGenerate = async () => {
    if (!count) return Swal.fire('Oops', 'Count field is empty')
    setOpenGenerateModal(false)
    setShowProgress(true);
    let response = await httpGet(`${customBaseUrl.qrCodeUrl}/api/v1/qrcode/generateQRCode/count/${count}`)
    showLoader();
    if (response.status) {
      hideLoader();
      Swal.fire('Success', response?.message);
      //setQRStatus( response?.message);
      setShowProgress(false);
      setCount('');
      getAll();
    } else {
      hideLoader();
    }
  }

  const handleReexport = async () => {
    const postData = {
      "dummyCardIds": selectedCards
    }
    showLoader();
    let response = await httpPost(`${customBaseUrl.cardUrl}/cms/cards/re-export`, postData, true, null, true)
    if (response && (response.status === true || response.message?.toLowerCase()?.includes('success'))) {
      hideLoader();
      Swal.fire('Success', response?.message);
      setShowProgress(false);
      setSelectedCards([]);
      getAll();
    } else {
      hideLoader();
      Swal.fire('Error', response?.message || 'Failed to re-export cards');
      setSelectedCards([]);
    }
  }

  const handleGenerateModal = () => {
    setOpenGenerateModal(true);
    // setQrData(qrValue);
  };

  const dropDownOptions = ["Create single user", "Upload excel sheet to create"];
  const handleDropdownAction = (item, row) => {
    if (item === "Create single user") handleGenerateModal();
    if (item === "Upload excel sheet to create") setOpenExcel(true)

  };

  useEffect(() => {
    const interval = setInterval(() => {
      setProg(50 + Math.floor(Math.random() * 50))
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  return (
    <section>
      <div className="search-wrapper">
        <div className="container">
          <div className="mechanics">
            <div className="mechanics-icon" style={{ cursor: 'pointer' }} onClick={() => setOpenExport(true)}>
              <div className="icon">
                <FaExternalLinkAlt />
              </div>
              <div className="export-data ">Export Bulk Cards</div>
            </div>
            <div onClick={() => { setOpenGenerateModal(true) }} style={{ cursor: 'pointer' }} className="mechanics-icon">
              <div className="icon">
                <FaPlus />
              </div>
              <div className="generate-code"
              >
                Generate Bulk Cards              </div>
            </div>

            <>
              <br />
              {showProgress && <Progress percent={prog} showInfo={false} />}
            </>
          </div>
          {selectedCards.length > 0 ? (
            <Button
              variant="contained"
              size="medium"
              style={{ background: '#009dff', color: '#fff', marginLeft: '10px' }}
              onClick={handleReexport}
              startIcon={<FaExternalLinkAlt />}
            >
              Re-export Selected Cards
            </Button>
          ) : (
            ''
          )}
        </div>
      </div>
      {openGenerateModal && (
        <GenCard
          setCount={setCount}
          count={count}
          handleGenerate={handleGenerate}
          showModal={openGenerateModal}
          hideModal={() => setOpenGenerateModal(false)}
          setRefresh={setRefresh}
        />
      )}
    </section>
  );
};

const BatchCardRequest = () => {
  const [batchRequests, setBatchRequests] = useState([]);
  const [refresh, setRefresh] = useState(false);

  const getBatchRequests = useCallback(async () => {
    showLoader();
    const res = await httpGet(`${customBaseUrl.cardUrl}/cms/card-batch`);
    if (res.status === true) {
      setBatchRequests(res.data);
    }
    hideLoader();
  }, []);

  const handleApprove = async (batchId) => {
    showLoader();
    const res = await httpPost(`${customBaseUrl.cardUrl}/cms/card-batch/approve/${batchId}`, {});
    if (res.status === true) {
      Swal.fire('Success', 'Batch approved successfully');
      setRefresh(!refresh);
    } else {
      Swal.fire('Error', res.message || 'Failed to approve batch');
    }
    hideLoader();
  };

  useEffect(() => {
    getBatchRequests();
  }, [refresh, getBatchRequests]);

  const columns = [
    { field: 'id', headerName: 'ID', width: 100 },
    {
      field: 'status',
      headerName: 'Approval Status',
      width: 150,
      renderCell: ({ row }) => (
        <span style={{ color: row.approved ? '#27AE60' : '#EB5757' }}>
          {row.approved ? 'Approved' : 'Pending Approval'}
        </span>
      ),
    },
    { field: 'createdBy', headerName: 'Created By', width: 250 },
    {
      field: 'approvedBy', headerName: 'Approved By', width: 250,
      renderCell: ({ row }) => row.approvedBy || 'N/A'
    },
    {
      field: 'createdAt',
      headerName: 'Created At',
      width: 200,
      renderCell: ({ row }) => moment(row.createdAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      field: 'updatedAt',
      headerName: 'Updated At',
      width: 200,
      renderCell: ({ row }) => moment(row.updatedAt).format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      field: 'action',
      headerName: 'Action',
      width: 150,
      renderCell: (params) => (
        <strong>
          <Button
            variant="contained"
            color="primary"
            size="small"
            onClick={() => handleApprove(params.row.id)}
            disabled={params.row.approved}
          >
            {params.row.approved ? 'Approved' : 'Approve'}
          </Button>
        </strong>
      ),
    },
  ];

  const rows = batchRequests?.map((row) => ({
    id: row.id,
    approved: row.approved,
    createdBy: row.createdBy,
    approvedBy: row.approvedBy,
    createdAt: row.createdAt,
    updatedAt: row.updatedAt,
  }));

  return (
    <Box
      sx={{
        width: 1,
        '& .super-app-theme--header': {
          background: '#ff6700',
          color: '#ffffff',
        },
      }}
    >
      <div
        style={{
          height: 650,
          width: '100%',
          background: '#fff',
          borderRadius: '8px',
        }}
      >
        {rows && rows.length > 0 ? (
          <DataGrid
            rows={rows}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            components={{ Toolbar: GridToolbar }}
            pagination
          />
        ) : (
          <p>No batch requests found.</p>
        )}
      </div>
    </Box>
  );
};


const BulkCard = ({ setShowManageQR }) => {
  const [selectedCards, setSelectedCards] = useState([]);
  const [selected, setSelected] = useState('Search by.....');
  const [state, setState] = useState([]);
  const [stat, setStat] = useState([]);
  const [assigned, setAssigned] = useState(0);
  const [unassigned, setUnassigned] = useState(0);
  const [count1, setCount1] = useState(0);
  const [qrData, setQrData] = useState([]);
  const [openModal, setOpenModal] = useState(false);
  const [opengenQr, setOpenGenQr] = useState(false);
  const [showManageMarkert, setShowManageMarkert] = useState(false);
  const [openExcel, setOpenExcel] = useState(false)
  const [openExport, setOpenExport] = useState(false);
  const [totalQRGen, setTotalQRGen] = useState(0);
  const [refresh, setRefresh] = useState(false);
  const [selectedRow, setSelectedRow] = useState({})
  const [pagination, setPagination] = useState({ current: 0, pageSize: 20 });
  const [totalCards, setTotalCards] = useState(0);
  const [totalExported, setTotalExported] = useState(0);
  const [count, setCount] = useState("");
  const [adminUsers, setAdminUsers] = useState([]);
  const [filterStatus, setFilterStatus] = useState('all');

  const renderDetailsButton = (params) => {
    const handleModal = (qrValue, row) => {
      setOpenModal(true);
      setQrData(qrValue);
      setSelectedRow(row);
    };
    return (
      <strong>
        <Button
          key={params?.row?.action?.id}
          variant="contained"
          size="small"
          style={{
            width: '120px',
            backgroundColor: '#FFF1EC',
            border: '1px solid #FF4B01',
            color: '#FF4B01',
          }}
          onClick={() => {
            handleModal(params?.row?.qrCode, params?.row?.action)
          }}
        >
          View QR Code
        </Button>
      </strong>
    );
  };
  const dropDownMarketerOpt = ["View users onboard"];
  const handleMarketerAction = (item, row) => {
    if (item === "View users onboard") setShowManageMarkert(true)

  };

  const columns = [
    {
      field: 'cardOwnerNam',
      headerName: 'select',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) => <input
        type="checkbox"
        // value={setting}
        checked={selectedCards.includes(row?.id)}
        onChange={(e) => {
          const { checked } = e.target;
          setSelectedCards(prevRoomType => checked ? [...prevRoomType, row?.id] : prevRoomType.filter(item => item !== row?.id));
          // // selectedCards.includes(row?.id) ? 
          // selectedCards.push(row?.id)
        }}
      />

    },
    {
      field: 'cardOwnerName',
      headerName: 'NAME',
      headerClassName: 'super-app-theme--header',
      width: 200,
    },
    {
      field: 'cardPan',
      headerName: 'CARD PAN',
      headerClassName: 'super-app-theme--header',
      width: 200,
    },
    {
      field: 'cardType',
      headerName: 'CARD TYPE',
      headerClassName: 'super-app-theme--header',
      width: 200,
    },
    {
      field: 'cardProduct',
      headerName: 'PRODUCT TYPE',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) => row?.cardProduct ? row?.cardProduct : 'N/A'
    },
    {
      field: 'expiryDate',
      headerName: 'EXPIRY DATE',
      headerClassName: 'super-app-theme--header',
      width: 200,
    },
    {
      field: 'assigned',
      headerName: 'ASSIGNMENT STATUS',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) =>
        <span
          style={{
            color: `${row.assigned ? "#27AE60" : "#EB5757"}`,
          }}
        >
          {row.assigned ? 'ASSIGNED' : 'UNASSIGNED'}
        </span>
    },
    {
      field: 'exportStatus',
      headerName: 'EXPORT STATUS',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) =>
        <span
          style={{
            color: `${row.exportStatus ? "#27AE60" : "#EB5757"}`,
          }}
        >
          {row.exportStatus ? 'EXPORTED' : 'NOT EXPORTED'}
        </span>
    },
    {
      field: 'dateExported',
      headerName: 'EXPORT DATE',
      headerClassName: 'super-app-theme--header',
      width: 200
    },
    {
      field: 'assignedBy',
      headerName: 'ASSIGNED BY',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) =>
        <span
          style={{
            color: `${row.assignedBy ? "#27AE60" : "#EB5757"}`,
          }}
        >
          {row.assignedBy ? row?.assignedBy : 'UNASSIGNED'}
        </span>
    },
    {
      field: 'dateAssigned',
      headerName: 'DATE ASSIGNED',
      headerClassName: 'super-app-theme--header',
      width: 200,
      renderCell: ({ row }) =>
        <span
          style={{
            color: `${row.dateAssigned ? "#27AE60" : "#EB5757"}`,
          }}
        >
          {row.dateAssigned ? row?.dateAssigned : 'UNASSIGNED'}
        </span>
    },
    {
      field: 'dateTimeCreated',
      headerName: 'DATE CREATED',
      headerClassName: 'super-app-theme--header',
      width: 250,
      renderCell: ({ row }) => row?.dateTimeCreated ? row?.dateTimeCreated : 'N/A'
    },
    {
      field: 'isActive',
      headerName: 'IS ACTIVE',
      headerClassName: 'super-app-theme--header',
      width: 150,
      renderCell: ({ row }) => (
        <span
          style={{
            color: `${row.isActive ? "#27AE60" : "#EB5757"}`,
            fontWeight: "500",
          }}
        >
          {row.isActive ? 'ACTIVE' : 'INACTIVE'}
        </span>
      )
    },
    {
      field: 'status',
      headerName: 'STATUS',
      headerClassName: 'super-app-theme--header',
      width: 150,
      renderCell: ({ row }) => (
        <span
          style={{
            color: row.status === 'APPROVED' || row.status === 'ASSIGNED' ? "#27AE60" : row.status === 'PENDING' ? "#F2994A" : "#EB5757",
            fontWeight: "500",
          }}
        >
          {row.status || 'N/A'}
        </span>
      )
    },
    {
      field: 'actions',
      headerName: 'Actions',
      headerClassName: 'super-app-theme--header',
      width: 150,
      renderCell: (params) => {
        const cardId = params.row.cardId ?? params.row.id;
        const isBlocked = params.row.blocked;
        const isActive = params.row.isActive;

        const handleAction = async (actionType) => {
          // showLoader();
          let res;
          let url;
          let successMessage;
          let errorMessage;

          switch (actionType) {
            case 'block':
              const { value: reason } = await Swal.fire({
                title: 'Block Card',
                input: 'text',
                inputLabel: 'Reason for blocking',
                inputPlaceholder: 'Enter reason here...',
                showCancelButton: true,
                inputValidator: (value) => {
                  if (!value) {
                    return 'You need to write something!';
                  }
                }
              });

              if (reason) {
                url = `${customBaseUrl.cardUrl}/cms/admin/admin-block-Card/${cardId}?reason=${encodeURIComponent(reason)}`;
                res = await httpPut(url, {}, null, true, true); // Assuming httpPost for PUT requests
                successMessage = 'Card blocked successfully';
                errorMessage = 'Failed to block card';
              } else {
                hideLoader();
                return;
              }
              break;
            case 'unblock':
              url = `${customBaseUrl.cardUrl}/cms/admin/admin-unblock-card/${cardId}`;
              res = await httpPut(url, {}, null, true, true); // Assuming httpPost for PUT requests
              successMessage = 'Card unblocked successfully';
              errorMessage = 'Failed to unblock card';
              break;
            case 'activate':
              const { value: pinValues } = await Swal.fire({
                title: 'Activate Card',
                html:
                  '<div style="margin-bottom: 10px; text-align: left;"><label style="font-weight: 500;">Default PIN</label>' +
                  '<input id="swal-default-pin" type="password" class="swal2-input" placeholder="Default PIN" value="1111" maxlength="4" style="margin-top: 5px; width: 80%;"></div>' +
                  '<div style="text-align: left;"><label style="font-weight: 500;">New PIN</label>' +
                  '<input id="swal-new-pin" type="password" class="swal2-input" placeholder="New PIN (4 digits)" maxlength="4" style="margin-top: 5px; width: 80%;"></div>',
                focusConfirm: false,
                showCancelButton: true,
                preConfirm: () => {
                  const defaultPin = document.getElementById('swal-default-pin').value;
                  const newPin = document.getElementById('swal-new-pin').value;
                  if (!defaultPin) {
                    Swal.showValidationMessage('Default PIN is required');
                    return false;
                  }
                  if (!newPin || newPin.length !== 4 || !/^\d+$/.test(newPin)) {
                    Swal.showValidationMessage('New PIN must be exactly 4 digits');
                    return false;
                  }
                  return { defaultPin, newPin };
                }
              });

              if (pinValues) {
                showLoader();
                url = `${customBaseUrl.cardUrl}/cms/admin/approvals/submit/activate`;
                res = await httpPost(url, {
                  cardId: parseInt(cardId, 10),
                  defaultPin: pinValues.defaultPin,
                  newPin: pinValues.newPin
                }, null, null, true);
                successMessage = 'Card activation request submitted successfully';
                errorMessage = 'Failed to submit card activation';
              } else {
                hideLoader();
                return;
              }
              break;
            case 'reset-pin':
              const { value: newPin } = await Swal.fire({
                title: 'Reset Card PIN',
                input: 'password',
                inputLabel: 'Enter New PIN',
                inputPlaceholder: 'New PIN (4 digits)',
                showCancelButton: true,
                inputAttributes: {
                  maxlength: 4,
                  autocapitalize: 'off',
                  autocorrect: 'off'
                },
                inputValidator: (value) => {
                  if (!value || value.length !== 4 || !/^\d+$/.test(value)) {
                    return 'New PIN must be exactly 4 digits';
                  }
                }
              });

              if (newPin) {
                showLoader();
                url = `${customBaseUrl.cardUrl}/cms/admin/approvals/submit/reset-pin`;
                res = await httpPost(url, {
                  cardId: parseInt(cardId, 10),
                  newPin: newPin
                }, null, null, true);
                successMessage = 'Card PIN reset request submitted successfully';
                errorMessage = 'Failed to submit card PIN reset';
              } else {
                hideLoader();
                return;
              }
              break;
            case 'deactivate':
              url = `${customBaseUrl.cardUrl}/cms/admin/card/deactivate/${cardId}`;
              res = await httpPut(url, {}, null, true, true); // Assuming httpPost for PUT requests
              successMessage = 'Card deactivated successfully';
              errorMessage = 'Failed to deactivate card';
              break;
            default:
              hideLoader();
              return;
          }

          if (res && (res.status === true || res.success === true || res.message === 'Card activated successfully' || res.message?.toLowerCase()?.includes('success'))) {
            Swal.fire('Success', successMessage);
            setRefresh(!refresh); // Refresh the table data
          } else {
            Swal.fire('Error', res?.message || errorMessage, 'error');
          }
          hideLoader();
        };

        const menu = (
          <Menu>
            <Menu.Item key="block" onClick={() => handleAction('block')} disabled={isBlocked}>
              Block Card
            </Menu.Item>
            <Menu.Item key="unblock" onClick={() => handleAction('unblock')} disabled={!isBlocked}>
              Unblock Card
            </Menu.Item>
            <Menu.Item key="activate" onClick={() => handleAction('activate')} disabled={isActive}>
              Activate Card
            </Menu.Item>
            <Menu.Item key="deactivate" onClick={() => handleAction('deactivate')} disabled={!isActive}>
              Deactivate Card
            </Menu.Item>
            <Menu.Item key="reset-pin" onClick={() => handleAction('reset-pin')} disabled={!isActive}>
              Reset PIN
            </Menu.Item>
          </Menu>
        );

        return (
          <Dropdown overlay={menu} trigger={['click']}>
            <Button variant="outlined" size="small">
              Actions <FaSortDown />
            </Button>
          </Dropdown>
        );
      },
    },
  ];

  const handleChangeRowsPerPage = async (value) => {
    setPagination({ ...pagination, current: 0, pageSize: value });
  };

  const handleChangePage = async (newPage) => {
    setPagination({ ...pagination, current: newPage });
  };


  const getAll = async (page, size, status = 'all') => {
    showLoader();
    const pages = page + 1; // DataGrid page is 0-indexed, API page is 1-indexed
    const limit = size;
    let url = `${customBaseUrl.cardUrl}/cms/cards`;

    if (status === 'all') {
      url = `${customBaseUrl.cardUrl}/cms/cards?items=${limit}&page=${pages}`;
    } else if (status === 'active') {
      url = `${customBaseUrl.cardUrl}/cms/cards/status/active?active=true&items=${limit}&page=${pages}`;
    } else if (status === 'approved') {
      url = `${customBaseUrl.cardUrl}/cms/cards/status/approved?approved=true`;
    } else if (status === 'assigned') {
      url = `${customBaseUrl.cardUrl}/cms/cards/status/assigned?assigned=true&items=${limit}&page=${pages}`;
    } else if (status === 'blocked') {
      url = `${customBaseUrl.cardUrl}/cms/cards/status/blocked?blocked=true&items=${limit}&page=${pages}`;
    } else if (status === 'cancelled') {
      url = `${customBaseUrl.cardUrl}/cms/cards/status/cancelled?cancelled=true&items=${limit}&page=${pages}`;
    } else if (status === 'exported') {
      url = `${customBaseUrl.cardUrl}/cms/cards/status/exported?exported=true&items=${limit}&page=${pages}`;
    }

    const res = await httpGet(url, null, true, false, null, false);
    if (res.status === true) {
      setState(res?.data?.preprintedCardDetailsDTOs || []);
      setTotalCards(res?.data?.pagingMetadataDTO?.total || 0);
    }
    hideLoader();
  }

  const getAdmin = async (page, size) => {
    showLoader();
    const pages = page ? page : 0;
    const limit = size ? size : 20;
    const res = await httpGet(
      `${customBaseUrl.authUrl}/api/v1/admin/users-admin-users?page=0&size=300`
    );
    if (res?._embedded?.userResponse) {
      hideLoader();
      const data = res;
      setAdminUsers(data?._embedded?.userResponse);
    } else if (res?.status === false) {
      hideLoader();
    } else {
      hideLoader();

    }
    hideLoader();
  }

  const getStat = async () => {
    showLoader();

    const res = await httpGet(
      `${customBaseUrl.cardUrl}/cms/cards/analysis`, null, true, false, null, true
    );
    if (res?.status === true) {
      hideLoader();
      const data = res;
      setStat(res?.data)
    } else {
      hideLoader();

    }
    hideLoader();
  }
  useEffect(() => {
    // getAdmin();
    getAll(pagination.current, pagination.pageSize, filterStatus);
    getStat();
  }, [refresh, filterStatus, pagination.current, pagination.pageSize]);


  const modalCloseAction = () => {
    setOpenModal(false);
    setOpenGenQr(false);
  }

  const handleManageMarketers = () => {
    setShowManageMarkert(true)
  }

  const rows = state?.map((row, index) => ({
    id: row?.id,
    userFullName: row.fullName,
    qrKey: row.qcode,
    age: row.status,
    phoneNo: row.phoneNumber,
    userType: row.userType,
    description: row.description,
    accountNo: row.accountNo,
    dateCreated: row.dateCreated,
    action: row,
  }));

  const handleGenerate = async () => {
    if (!count) return Swal.fire('Oops', 'Count field is empty')
    modalCloseAction();
    let response = await httpGet(`${customBaseUrl.cardUrl}/dummy-account/createBulk/${count}`)
    showLoader();
    if (response.status) {
      hideLoader();
      Swal.fire('Success', response?.message);
      //setQRStatus( response?.message);
      // hideModal(false);
    } else {
      // hideLoader();
    }
  }

  return (
    <>
      <div className="App">
        <Tabs defaultActiveKey="1">
          <TabPane tab="Manage Bulk Cards" key="1">
            <div>
              <Search setSelectedCards={setSelectedCards} selectedCards={selectedCards} refresh={refresh} setRefresh={setRefresh} setOpenExport={setOpenExport} getAll={getAll} handleManageMarketers={setShowManageMarkert} setOpenExcel={setOpenExcel} selected={selected} setSelected={setSelected} />
              <div className="filter-select" style={{ marginBottom: '20px' }}>
                <Select
                  defaultValue="all"
                  style={{ width: 120 }}
                  onChange={(value) => setFilterStatus(value)}
                  options={[
                    { value: 'all', label: 'All' },
                    { value: 'active', label: 'Active' },
                    { value: 'approved', label: 'Approved' },
                    { value: 'assigned', label: 'Assigned' },
                    { value: 'blocked', label: 'Blocked' },
                    { value: 'cancelled', label: 'Cancelled' },
                    { value: 'exported', label: 'Exported' },
                  ]}
                />
              </div>
              <div className="cards-container">
                <div className="cards">
                  <p>Total Bulk Cards</p>
                  <h2>{stat?.totalGeneratedCards ?? 0}</h2>
                </div>
                <div className="cards">
                  <p>Total Exported Bulk Cards</p>
                  <h2>{stat?.totalExportedCards ?? 0}</h2>
                </div>
                <div className="cards">
                  <p>Total Assigned Bulk Cards</p>
                  <h2>{stat?.totalAssignedCards ?? 0}</h2>
                </div>
                <div className="cards">
                  <p>Total Pending Cards</p>
                  <h2>{stat?.totalPendingCards ?? 0}</h2>
                </div>
              </div>
            </div>
            {//<Status selected={selected} setSelected={setSelected} />
            }
            <Box
              sx={{
                width: 1,
                '& .super-app-theme--header': {
                  background: '#ff6700',
                  color: '#ffffff',
                },
              }}
            >
              <div
                style={{
                  height: 650,
                  width: '100%',
                  background: '#fff',
                  borderRadius: '8px',
                }}
              >
                {state.length > 0 && <DataGrid
                  // getRowId={row=>row.cardPan}
                  rows={state}
                  columns={columns}
                  rowHeight={125}
                  page={pagination.current}
                  // paginationMode="server"
                  paginationMode="server"
                  pageSize={pagination.pageSize}
                  onPageSizeChange={(newPageSize) =>
                    handleChangeRowsPerPage(newPageSize)
                  }
                  onPageChange={(newPage) => handleChangePage(newPage)}
                  rowsPerPageOptions={[5, 10, 20, 50, 100]}
                  pagination
                  components={{ Toolbar: GridToolbar }}
                  rowCount={totalCards}

                />}
              </div>
            </Box>
          </TabPane>
          <TabPane tab="Batch Card Request" key="2">
            <BatchCardRequest />
          </TabPane>
        </Tabs>
      </div>
      {openModal && <GeneratedQr modalState={openModal} modalCloseAction={modalCloseAction} qrValue={qrData} selectedRow={selectedRow} />}

      {
        openExcel &&
        <ExcelUpload
          showModal={openExcel}
          hideModal={setOpenExcel}
        />
      }
      {
        openExport &&
        <ExportQr
          showModal={openExport}
          hideModal={setOpenExport}
          adminUsers={adminUsers}
        />
      }
    </>
  );
}

export default BulkCard;
